<template>
    <div class="popup-container">
        <div>
            <img :src='brandLogo'/>
            <span>{{ brandName }}</span>
            <p>{{ brandDescription }}</p>
            <button @click="hideProfile">
                Start Conversation
            </button>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
    name: 'StartConversationPopup',
    methods: {
        ...mapMutations({
            showProfile: 'theme/showProfile'
        }),
        hideProfile(){
            sessionStorage.setItem('start-conversation', true);
            this.showProfile(false)
            let container = document.querySelector('.popup-container')
            console.log(container)
            container.style.top = '100%'
            container.style.opacity = 0
            
        }
    },
    computed: {
        brandName() {
            return this.$store.getters['theme/brandName'];
        },
        brandLogo() {
            return this.$store.getters['theme/brandLogo'];
        },
        brandDescription() {
            return this.$store.getters['theme/brandDescription'];
        },
    },
}
</script>

<style lang="scss" scoped>
.popup-container {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: rgb(255, 255, 255);
    z-index: 9999;
    top: 0;
    transition: 0.7s;

  > div {   
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 80%;
    text-align: center;

    img {
      width: 100px;
      height: 70px;
      object-fit: cover;
    }

    span {
      margin-top: 10px;
      margin-bottom: 10px;
      color: #3a3a3a;
      font-size: 14px;
      font-weight: 600;
      font-family: 'Roboto';
    }

    p {
      margin-bottom: 18px;
      color: #3a3a3a;
      font-size: 14px;
      font-weight: 600;
      font-family: 'Roboto';
    }

    button {
      padding: 6px 11px;
      border-radius: 5px;
      background: #3a3a3a;
      color: white;
      font-size: 14px;
    }
  }
}
</style>